import React, { useEffect, useState } from 'react';
import styled, { createGlobalStyle, keyframes } from 'styled-components';
import Facebook from '../Assets/facebookicon.svg';
import Google from '../Assets/googleicon.svg';
import Logo from '../Assets/Logo.png';
import { FaEye, FaEyeSlash, FaSpinner } from 'react-icons/fa';
import useRegister from '../Hooks/RegisterHooks/useRegister2';
import { ToastContainer, toast } from 'react-toastify';
import 'react-toastify/dist/ReactToastify.css';

const GlobalStyle = createGlobalStyle`
  @keyframes shine {
    0% { transform: translateX(-100%) rotate(25deg); }
    100% { transform: translateX(100%) rotate(25deg); }
  }

  @keyframes flipLogo {
    0% { transform: rotateY(0deg); }
    100% { transform: rotateY(360deg); }
  }

  @keyframes spin {
    0% { transform: rotate(0deg); }
    100% { transform: rotate(360deg); }
  }
`;

const RegisterModal = ({ isOpen, closeRegister }) => {
  const {
  name, setName, code, setCode,
  password, setPassword, confirmPassword, setConfirmPassword,
  error, success, setError, setSuccess, handleSubmit,
  role, setRole
} = useRegister();


  const [showPassword, setShowPassword] = useState(false);
  const [showConfirmPassword, setShowConfirmPassword] = useState(false);
  const [isSubmitting, setIsSubmitting] = useState(false);

  useEffect(() => {
    if (success) {
      toast.success(success, { autoClose: 3000 });
      setSuccess(null);
      setIsSubmitting(false);
    }
    if (error) {
      toast.error(error, { autoClose: 3000 });
      setError(null);
      setIsSubmitting(false);
    }
  }, [success, error, setSuccess, setError]);

  if (!isOpen) return null;

  const onFormSubmit = async (e) => {
    e.preventDefault();
    setIsSubmitting(true);
    await handleSubmit(e);
  };

  return (
    <>
      <GlobalStyle />
      <ToastContainer />
      <Modal>
        <ModalContent>
          <RightContainer>
            <CurvedTop />
            <LogoWrapper>
              <LogoFlip>
                <LogoFace src={Logo} alt="Logo Front" />
                <LogoBack src={Logo} alt="Logo Back" />
              </LogoFlip>
            </LogoWrapper>

            <LoginTitle>
              <TopRow><span>Sign</span><span>Up</span></TopRow>
            </LoginTitle>

            <CloseButton onClick={closeRegister}>&times;</CloseButton>

            <SignInForm onSubmit={onFormSubmit}>
              <FormField>
        <InputLabel>Code</InputLabel>
        <Input
          type="number"
          placeholder="Enter your code"
          value={code}
          onChange={(e) => setCode(e.target.value)}
          required
        />
                    </FormField>
              <FormField>
                <InputLabel>Name</InputLabel>
                <Input
                  type="text"
                  placeholder="Enter your name"
                  value={name}
                  onChange={(e) => setName(e.target.value)}
                  required
                />
              </FormField>


              <FormField>
                <InputLabel>Password</InputLabel>
                <PasswordInputWrapper>
                  <Input
                    type={showPassword ? 'text' : 'password'}
                    placeholder="Enter your password"
                    value={password}
                    onChange={(e) => setPassword(e.target.value)}
                    required
                  />
                  <PasswordToggleIcon onClick={() => setShowPassword(!showPassword)}>
                    {showPassword ? <FaEyeSlash /> : <FaEye />}
                  </PasswordToggleIcon>
                </PasswordInputWrapper>
              </FormField>

              <FormField>
                <InputLabel>Confirm Password</InputLabel>
                <PasswordInputWrapper>
                  <Input
                    type={showConfirmPassword ? 'text' : 'password'}
                    placeholder="Confirm your password"
                    value={confirmPassword}
                    onChange={(e) => setConfirmPassword(e.target.value)}
                    required
                  />
                  <PasswordToggleIcon onClick={() => setShowConfirmPassword(!showConfirmPassword)}>
                    {showConfirmPassword ? <FaEyeSlash /> : <FaEye />}
                  </PasswordToggleIcon>
                </PasswordInputWrapper>
              </FormField>

              <FormField>
                <InputLabel>Role</InputLabel>
                <Select value={role} onChange={(e) => setRole(e.target.value)} required>
                  <Option value="">Select Role</Option>
                 <Option value="admin">Admin</Option>
                  <Option value="noso">Noso</Option>
                  <Option value="bohol">Bohol</Option>
                  <Option value="siquijor">Siquijor</Option>
                  <Option value="cebu">Cebu</Option>
                  <Option value="nis">NIS</Option>

                </Select>
              </FormField>

              <SubmitButton type="submit" disabled={isSubmitting}>
                {isSubmitting ? (
                  <SpinnerWrapper><FaSpinner /></SpinnerWrapper>
                ) : 'Sign Up'}
              </SubmitButton>

              <OtherWaysToSignIn>
                <OtherWaysText>Other ways to sign up</OtherWaysText>
                <IconsContainer>
                  <IconLink href="#"><Icon src={Facebook} alt="Facebook" /></IconLink>
                  <IconLink href="#"><Icon src={Google} alt="Google" /></IconLink>
                </IconsContainer>
              </OtherWaysToSignIn>

              <SignUpPrompt>
                Already have an account?{' '}
                <SignUpLink onClick={closeRegister}>Login here</SignUpLink>
              </SignUpPrompt>
            </SignInForm>
          </RightContainer>
        </ModalContent>
      </Modal>
    </>
  );
};

export default RegisterModal;


// ========== Styled Components ==========
const Modal = styled.div`
  position: fixed;
  top: 0; left: 0;
  width: 100%; height: 100%;
  display: flex; justify-content: center; align-items: center;
  background-color: rgba(0, 0, 0, 0.5);
  z-index: 6;
`;

const ModalContent = styled.div`
  width: 50%; max-width: 500px; min-width: 300px;
  height: auto;
  padding-bottom: 20px;
  display: flex; flex-direction: column;
  border-radius: 15px;
  background: rgba(255, 255, 255, 0.95);
  overflow: hidden; position: relative;

  @media (max-width: 768px) {
    width: 80%;
  }

  @media (max-width: 500px) {
    width: 95%;
  }
`;

const RightContainer = styled.div`
  display: flex; flex-direction: column; align-items: center;
  width: 100%; padding: 30px 20px 20px;
  position: relative;

  @media (max-width: 500px) {
    padding: 20px 15px;
  }
`;

const CurvedTop = styled.div`
  position: absolute;
  top: 0;
  width: 100%; height: 150px;
  background: linear-gradient(45deg, #18591d, #00ff7f);
  border-bottom-left-radius: 50% 75%;
  border-bottom-right-radius: 50% 75%;
  overflow: hidden;
  z-index: 0;

  &::after {
    content: '';
    position: absolute;
    top: -50%;
    left: -75%;
    width: 200%;
    height: 200%;
    background: linear-gradient(120deg, transparent 30%, rgba(255, 255, 255, 0.3) 50%, transparent 70%);
    transform: rotate(25deg);
    animation: shine 3s linear infinite;
  }
`;

const LogoWrapper = styled.div`
  perspective: 1000px;
  width: 80px; height: 80px;
  margin-top: -9px;
  z-index: 2;

  @media (max-width: 500px) {
    width: 65px; height: 65px;
  }
`;

const LogoFlip = styled.div`
  width: 100%; height: 100%;
  position: relative;
  transform-style: preserve-3d;
  animation: flipLogo 6s linear infinite;
`;

const LogoFace = styled.img`
  position: absolute;
  width: 100%; height: 100%;
  backface-visibility: hidden;
  border-radius: 50%;
`;

const LogoBack = styled(LogoFace)`
  transform: rotateY(180deg);
`;

const LoginTitle = styled.div`
  position: absolute;
  top: 100px;
  left: 50%;
  transform: translateX(-50%);
  text-align: center;
  font-weight: 700;
  color: white;
  z-index: 2;

  @media (max-width: 500px) {
    top: 90px;
    font-size: 1.5rem;
  }
`;

const TopRow = styled.div`
  display: flex;
  justify-content: center;
  gap: 11px;
  font-size: 1.8rem;
  font-family: 'Poppins', sans-serif;

  @media (max-width: 768px) {
    font-size: 1.5rem;
  }

  @media (max-width: 500px) {
    font-size: 1.3rem;
    gap: 8px;
  }
`;

const CloseButton = styled.span`
  position: absolute; top: 20px; right: 20px;
  font-size: 2.5rem;
  color: green; cursor: pointer;

  @media (max-width: 500px) {
    font-size: 2rem;
  }
`;

const SignInForm = styled.form`
  display: flex; flex-direction: column; align-items: center;
  width: 80%; margin-top: 35px;

  @media (max-width: 500px) {
    width: 90%;
    margin-top: 30px;
  }
`;

const FormField = styled.div`
  margin: 15px 0 10px;
  width: 100%;
`;

const InputLabel = styled.label`
  font-size: 0.9rem;
  font-weight: bold;
  margin-bottom: 5px;
  display: block;
  color: #000;

  @media (max-width: 500px) {
    font-size: 0.85rem;
  }
`;

const Input = styled.input`
  font-family: 'Poppins';
  width: 100%; padding: 10px;
  border-radius: 8px; font-size: 1.1rem;
  border: 1px solid #c4c4c4;

  &:focus {
    border-color: #185faf;
    box-shadow: 0 0 10px rgba(24, 89, 29, 0.5);
    outline: none;
  }

  @media (max-width: 500px) {
    font-size: 1rem;
    padding: 8px;
  }
`;

const Select = styled.select`
  font-family: 'Poppins';
  padding: 10px;
  font-size: 1.1rem;
  border-radius: 8px;
  width: 100%;
  border: 1px solid #c4c4c4;

  &:focus {
    border-color: #185faf;
    box-shadow: 0 0 10px rgba(24, 89, 29, 0.5);
    outline: none;
  }

  @media (max-width: 500px) {
    font-size: 1rem;
    padding: 8px;
  }
`;

const Option = styled.option``;

const PasswordInputWrapper = styled.div`
  position: relative;
`;

const PasswordToggleIcon = styled.span`
  position: absolute;
  right: 10px; top: 50%;
  transform: translateY(-50%);
  cursor: pointer;
  font-size: 20px;

  @media (max-width: 500px) {
    font-size: 18px;
  }
`;

const SubmitButton = styled.button`
  width: 100%; padding: 13px;
  background: linear-gradient(45deg, #18591d, #00ff7f);
  color: white;
  border: none;
  border-radius: 25px;
  font-size: 1.2rem;
  position: relative;
  overflow: hidden;
  cursor: pointer;
  font-family: 'Poppins';

  &::after {
    content: '';
    position: absolute;
    top: -50%; left: -75%;
    width: 200%; height: 200%;
    background: linear-gradient(120deg, transparent 30%, rgba(255, 255, 255, 0.3) 50%, transparent 70%);
    transform: rotate(25deg);
    animation: shine 3s linear infinite;
    z-index: 2;
  }

  &:hover {
    transform: scale(1.05);
    transition: all 0.3s ease;
  }

  @media (max-width: 500px) {
    font-size: 1rem;
    padding: 10px;
  }
`;

const OtherWaysToSignIn = styled.div`
  margin-top: 15px; text-align: center;

  @media (max-width: 500px) {
    margin-top: 10px;
  }
`;

const OtherWaysText = styled.p`
  font-size: 0.8rem; color: #080808;

  @media (max-width: 500px) {
    font-size: 0.75rem;
  }
`;

const IconsContainer = styled.div`
  display: flex; justify-content: center;
  margin-top: 5px;

  @media (max-width: 500px) {
    margin-top: 3px;
  }
`;

const IconLink = styled.a`
  margin: 0 15px; cursor: pointer;
`;

const Icon = styled.img`
  width: 35px; height: 35px;
  border-radius: 50%;
  transition: transform 0.3s ease;

  &:hover {
    transform: scale(1.1);
    opacity: 0.8;
  }

  @media (max-width: 500px) {
    width: 30px; height: 30px;
  }
`;

const SignUpPrompt = styled.p`
  margin-top: 10px;
  text-align: center;
  font-size: 1.1rem;
  color: #333;

  @media (max-width: 500px) {
    font-size: 1rem;
  }
`;

const SignUpLink = styled.a`
  color: rgb(43, 177, 103);
  font-weight: bold;
  text-decoration: none;
  cursor: pointer;

  &:hover {
    text-decoration: underline;
  }
`;
const SpinnerWrapper = styled.div`
  display: flex;
  justify-content: center;
  align-items: center;
  animation: spin 1s linear infinite;
`;



